module.exports = __webpack_public_path__ + "static/media/best_buy.fc2156e3.svg";